import { useAuth0 } from '@auth0/auth0-react';
import BannerImagePart1 from '../../../assets/banners/homepage-welcome.jpg';
import BannerImagePart2 from '../../../assets/banners/homepage-welcome-p2.jpg';
import BannerImagePart3 from '../../../assets/banners/homepage-welcome-p3.jpg';
import BannerImagePart4 from '../../../assets/banners/homepage-welcome-p4.jpg';

/**
 * Welcome landing page for unauthenticated users
 * @returns
 */
const WelcomeLoggedOutPage = () => {
  const { loginWithRedirect, isLoading: auth0IsLoading } = useAuth0();

  return (
    <>
      {!auth0IsLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 w-full h-screen">
          <div className="flex bg-gray-100 w-full justify-center">
            <div className="grid grid-cols-2 mt-20 gap-4 w-8/12 h-3/4">
              <div className="flex flex-col gap-4 h-full w-full min-h-0">
                <div className="h-5/12">
                  <img
                    className="h-full w-full object-cover rounded-4xl"
                    src={BannerImagePart1}
                    alt=""
                  />
                </div>
                <div className="h-6/12">
                  <img
                    className="h-full w-full object-cover rounded-4xl"
                    src={BannerImagePart4}
                    alt=""
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4 h-full w-full min-h-0">
                <div className="h-6/12">
                  <img
                    className="h-full w-full object-cover rounded-4xl"
                    src={BannerImagePart2}
                    alt=""
                  />
                </div>
                <div className="h-5/12">
                  <img
                    className="h-full w-full object-cover rounded-4xl"
                    src={BannerImagePart3}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex bg-white w-full justify-center mb-20 md:mb-0">
            <div className="flex flex-col mt-20 w-5/12 md:w-2/3 2xl:w-6/12">
              <h1 className="md:mt-4 lg:mt-20 text-3xl font-bold">
                Welcome to the Admin Insurance Portal!
              </h1>
              <p className="text-xl font-bold mt-6">
                Student care with a different perspective
              </p>
              <p className="mt-6 mb-6">
                Log into the Admin Insurance Portal to access your policy
                details, submit a claim and much more.
              </p>

              <div className="flex flex-col gap-y-4 my-6">
                <a
                  href="tel:1-888-575-1231"
                  className="text-ingle-light-purple bg-white border-ingle-light-purple border-2 hover:bg-ingle-dark-purple hover:text-white rounded-sm px-12 py-3 text-sm font-bold text-center"
                >
                  Need help? Please call +1-888-575-1231
                </a>
                <button
                  onClick={() => loginWithRedirect()}
                  className="text-ingle-light-purple bg-white border-ingle-light-purple border-2 hover:bg-ingle-dark-purple hover:text-white rounded-sm px-12 py-3 text-sm font-bold hover:cursor-pointer"
                >
                  Log In
                </button>
                <button
                  onClick={() =>
                    loginWithRedirect({
                      authorizationParams: { screen_hint: 'signup' },
                    })
                  }
                  className="text-white bg-ingle-light-purple border-ingle-light-purple border-2 hover:bg-ingle-dark-purple hover:text-white rounded-sm px-12 py-3 text-sm font-bold hover:cursor-pointer"
                >
                  Create an account
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default WelcomeLoggedOutPage;
